export default "__VITE_ASSET__CyegPAyU__"